<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <div class="columns">
          <div class="column">
            <form-group name="deposit" :label="$t('attributes.deposit')">
              <b-input
                v-model.number="form.deposit"
                name="deposit"
                type="number"
                min="0"
                :placeholder="
                  $t('message.please_input') + $t('attributes.deposit')
                "
              ></b-input>
            </form-group>
          </div>
          <div class="column">
            <form-group name="hide_price" :label="$t('attributes.hide_price')">
              <b-select v-model="form.hide_price" name="hide_price">
                <option value="N">{{ $t('attributes.display') }}</option>
                <option value="Y">{{ $t('attributes.hide') }}</option>
              </b-select>
            </form-group>
          </div>
          <div class="column">
            <form-group name="show_up" :label="$t('attributes.show_up')">
              <b-select v-model="form.show_up" name="show_up">
                <option value="Y">{{ $t('attributes.yes') }}</option>
                <option value="N">{{ $t('attributes.no') }}</option>
              </b-select>
            </form-group>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <form-group name="tip_fee" :label="$t('attributes.tip_fee')">
              <b-field>
                <b-select v-model="form.tip_flag" name="tip_flag">
                  <option value="Y">{{ $t('attributes.included') }}</option>
                  <option value="N">{{ $t('attributes.excluded') }}</option>
                </b-select>
                <b-input
                  v-model.number="form.tip_fee"
                  name="tip_fee"
                  type="number"
                  min="0"
                  :placeholder="
                    $t('message.please_input') + $t('attributes.tip_fee')
                  "
                  expanded
                ></b-input>
              </b-field>
            </form-group>
          </div>

          <div class="column">
            <form-group
              name="insurance_fee"
              attributes="tax_fee"
              :label="$t('attributes.tax_fee')"
            >
              <b-field>
                <b-select v-model="form.insurance_flag" name="insurance_flag">
                  <option value="Y">{{ $t('attributes.included') }}</option>
                  <option value="N">{{ $t('attributes.excluded') }}</option>
                </b-select>
                <b-input
                  v-model.number="form.insurance_fee"
                  name="insurance_fee"
                  type="number"
                  min="0"
                  :placeholder="
                    $t('message.please_input') + $t('attributes.tax_fee')
                  "
                  expanded
                ></b-input>
              </b-field>
            </form-group>
          </div>
          <div class="column">
            <form-group name="visa_fee" :label="$t('attributes.visa_fee')">
              <b-field>
                <b-select v-model="form.visa_flag" name="visa_flag">
                  <option value="Y">{{ $t('attributes.included') }}</option>
                  <option value="N">{{ $t('attributes.excluded') }}</option>
                  <option value="X">{{ $t('attributes.visa_free') }}</option>
                </b-select>
                <b-input
                  v-model.number="form.visa_fee"
                  name="visa_fee"
                  type="number"
                  min="0"
                  :placeholder="
                    $t('message.please_input') + $t('attributes.visa_fee')
                  "
                  expanded
                ></b-input>
              </b-field>
            </form-group>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <form-group
              name="discount_limit"
              :label="$t('attributes.discount_limit')"
            >
              <b-input
                v-model="form.discount_limit"
                name="discount_limit"
                type="number"
                min="0"
                style="max-width: 353px;"
                :placeholder="
                  $t('message.please_input') + $t('attributes.discount_limit')
                "
              ></b-input>
            </form-group>
          </div>
        </div>

        <b-field>
          <div class="buttons is-right">
            <b-button :loading="sending" type="is-primary" native-type="submit">
              {{ $t('attributes.update_cost_data') }}
            </b-button>
          </div>
        </b-field>
      </form-wrapper>
    </form>
  </section>
</template>

<script>
import { required, numeric, minValue } from 'vuelidate/lib/validators'
import { PRODUCTS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'ProductCostForm',

  props: {
    product: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,
      form: this.extractFormValues(this.product),

      travelerTypes: [],

      isFormModalActive: false,
      selectedTravelerTypes: null
    }
  },

  validations: {
    form: {
      deposit: { required, numeric, minValue: minValue(0) },

      tip_flag: {},
      tip_fee: { required, numeric, minValue: minValue(0) },
      insurance_flag: {},
      insurance_fee: { required, numeric, minValue: minValue(0) },
      visa_flag: {},
      visa_fee: { required, numeric, minValue: minValue(0) },
      discount_limit: { required, numeric, minValue: minValue(0) },

      hide_price: {},
      show_up: {}
    }
  },
  watch: {
    product(newProduct) {
      this.form = this.extractFormValues(newProduct)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        code: data.code,
        deposit: data.deposit || 0,

        tip_flag: data.tip_flag ? data.tip_flag.trim() : 'N',
        tip_fee: data.tip_fee || 0,
        insurance_flag: data.insurance_flag ? data.insurance_flag.trim() : 'N',
        insurance_fee: data.insurance_fee || 0,
        visa_flag: data.visa_flag ? data.visa_flag.trim() : 'N',
        visa_fee: data.visa_fee || 0,
        discount_limit: data.discount_limit || 0,

        hide_price: data.hide_price ? data.hide_price.trim() : 'N',
        show_up: data.show_up ? data.show_up.trim() : 'N'
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${PRODUCTS_API}/${this.form.code}/cost`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)
        this.$emit('updated', res.data.data)
        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
